export const formatViews = (views?: number): string => {
  if (!views) {
    return '0'
  }
  if (views >= 1000000) {
    return `${(views / 1000000).toFixed(1)}M`
  }
  if (views >= 1000) {
    return `${Math.trunc(views / 1000)}K`
  }
  if (views >= 100) {
    return `${Math.trunc(views / 100) * 100}`
  }

  return '<100'
}

export const formatLikes = (likes?: number): string => {
  if (!likes) {
    return '0'
  }

  return Intl.NumberFormat().format(likes)
}
